import { Box, Link } from "@mui/material";
import MaterialTable from "material-table";
import React, { useState } from "react";
import ReviewForm from "./ReviewForm";
import { ConvertDate } from "../../../Base/helper/baseFunctions";

const MyReporteesPage = () => {
    const [openReviewForm, setOpenReviewForm] = useState(false);
    const [currentStage, setCurrentStage] = useState(1);
  return (
    <Box pt={1.5} sx={{ height: "calc(100vh - 155px)", overflowY: 'auto'}}>
     {!openReviewForm ? (
        <MaterialTable
        columns={[
          {
            title: "Title",
            field: "title",
            render: (rowData) => {
              const isDisabled = rowData?.status === "Window Not Open";
             return (<Link
                href="#"
                underline="hover"
                 color={isDisabled ? "text.disabled" : "primary"}
                onClick={(e) => {
                  e.preventDefault();
                  if (isDisabled) return;
                  setOpenReviewForm(true);
                  setCurrentStage(rowData?.currentStep)
                }}
                sx={{
                  pointerEvents: isDisabled ? "none" : "auto",
                  cursor: isDisabled ? "default" : "pointer",
                }}
              >
                {rowData.title}
              </Link>
            )},
          },
          { title: "Employee", field: "employee" },
          { title: "Status", field: "status" },
          { title: "Completed On", field: "completedOn", render: (rowData) => ConvertDate(rowData?.completedOn) },
        ]}
        data={reviewData}
        options={{
          maxBodyHeight: "calc(100vh - 280px)",
          minBodyHeight: "calc(100vh - 280px)",
          rowStyle: {
            fontSize: "13px",
            height: "35px",
          },
          cellStyle: {
            padding: "5px 0px 5px 13px",
          },
          headerStyle: {
            padding: "5px 10px 5px 10px",
            fontWeight: "bold",
          },
          sorting: true,
          search: true,
          searchText: "",
          searchFieldAlignment: "right",
          searchAutoFocus: false,
          searchFieldVariant: "standard",
          filtering: false,
          paging: true,
          pageSizeOptions: [25, 50],
          pageSize: 25,
          paginationType: "stepped",
          showFirstLastPageButtons: false,
          paginationPosition: "bottom",
          exportButton: false,
          exportAllData: false,
          exportFileName: "Employees",
          addRowPosition: "first",
          selection: false,
          actionsColumnIndex: -1,
          grouping: false,
          columnsButton: false,
        }}
        title={""}
      />
     ) : (
       <ReviewForm setOpenReviewForm={setOpenReviewForm} currentStep={currentStage} mode={"Manager"} />
     )} 
    </Box>
  );
};

const reviewData = [
  {
    title: "Review Form 2025",
    employee: "My Name",
    status: "Window Not Open",
    completedOn: "",
    currentStep: 0
  },
  {
    title: "Review Form 2025",
    employee: "My Name",
    status: "Employee Review",
    completedOn: "",
    currentStep: 0
  },
  {
    title: "Review Form 2024",
    employee: "My Name",
    status: "Manager Review",
    completedOn: "2024-12-15",
    currentStep: 1
  },
  {
    title: "Review Form 2023",
    employee: "My Name",
    status: "Review Closed",
    completedOn: "2023-12-19",
    currentStep: 3
  },
];

export default MyReporteesPage;
